import { render, staticRenderFns } from "./CC.vue?vue&type=template&id=5f327a02&"
import script from "./CC.vue?vue&type=script&lang=js&"
export * from "./CC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports